'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var editorOptions = ['minLines', 'maxLines', 'readOnly', 'highlightActiveLine', 'tabSize', 'enableBasicAutocompletion', 'enableLiveAutocompletion', 'enableSnippets'];

var editorEvents = ['onChange', 'onFocus', 'onInput', 'onBlur', 'onCopy', 'onPaste', 'onSelectionChange', 'onCursorChange', 'onScroll', 'handleOptions', 'updateRef'];
var getAceInstance = function getAceInstance() {
  var ace = void 0;
  // Fallback for ace.require when vanilla ACE is hosted over a CDN
  if (window.ace) {
    ace = window.ace;
    ace.acequire = window.ace.require || window.ace.acequire;
  } else {
    ace = require('brace');
  }
  return ace;
};

var debounce = function debounce(fn, delay) {
  var timer = null;
  return function () {
    var context = this,
        args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};
exports.editorOptions = editorOptions;
exports.editorEvents = editorEvents;
exports.debounce = debounce;
exports.getAceInstance = getAceInstance;


//////////////////
// WEBPACK FOOTER
// ./~/react-ace/lib/editorOptions.js
// module id = 714
// module chunks = 0